













































































































































import { Component, Prop, Vue, Mixins, Watch } from 'vue-property-decorator'
import VisitorsApi from '@/api/visitor'
import PartnerApi from '@/api/partner'
import analysisList from '@/views/partner/order/List.vue'
import commentList from '@/views/partner/visitor/commentList.vue'
import { download } from '@/utils/util'
import moment from 'moment'
let unwatch: any = ''

@Component({
	components: {
		analysisList,
		commentList,
	},
})
export default class Tabs extends Vue {
	@Prop()
	private activeKey!: any

	private exportingList: boolean = false
	private info: any = {}
	private basicInfo: any = {
		// 避免初始时报错
		examList: [],
	}
	private visible: boolean = false
	private logList: any = []
	private get commonTasktypeMap(): any {
		return Object.assign(
			{},
			this.$store.state.setting.injuredTasktypeMap,
			this.$store.state.setting.surveryTasktypeMap,
			this.$store.state.setting.conciliationTasktypeMap
		)
	}

	private get infoList() {
		return [
			{
				label: '作业人员姓名',
				value: this.info.vistorName,
			},
			{
				label: '作业人员电话',
				value: this.info.visitorPhone,
			},
			{
				label: '作业人员所在地区',
				value: this.info.area,
			},
			{
				label: '作业人员所属资源公司',
				value: this.info.vistorCompany,
			},
			{
				label: '作业人员综合评分',
				value: `${this.info.synthesizeRating || ''}分`,
			},
			{
				label: '保险公司综合评分',
				value: `${this.info.insuranceRating || ''}分`,
			},
			{
				label: '伤者/家属综合评分',
				value: `${this.info.injuryRating || ''}分`,
			},
			{
				label: '总派单数',
				value: this.getNumStr(this.info.dispatchNum),
			},
			{
				label: '订单完成总数',
				value: `${this.getNumStr(this.info.finishNum)} / ${this.info
					.finishRate || ''}`,
			},
			{
				label: '订单平均作业时长',
				value: this.info.avgWorkTime,
			},
			{
				label: '订单平均完成时长',
				value: this.info.avgFinishTime,
			},
			{
				label: '主动撤单数',
				value: `${this.getNumStr(this.info.cancelNum)} / ${this.info
					.cancelRate || ''}`,
			},
			{
				label: '被动撤单数',
				value: `${this.getNumStr(this.info.passiveCancelNum)} / ${this.info
					.passiveCancelRate || ''}`,
			},
			{
				label: '订单审核退回数',
				value: `${this.getNumStr(this.info.backNum)} / ${this.info.backRate ||
					''}`,
			},
			{
				label: '订单关单数',
				value: `${this.getNumStr(this.info.closeNum)} / ${this.info.closeRate ||
					''}`,
			},
			{
				label: '订单超时数',
				value: `${this.getNumStr(this.info.overNum)} / ${this.info.overRate ||
					''}`,
			},
			{
				label: '订单延时数',
				value: `${this.getNumStr(this.info.delayNum)} / ${this.info.delayRate ||
					''}`,
			},
			{
				label: '订单伤者签字数',
				value: `${this.getNumStr(this.info.signNum)} / ${this.info.signRate ||
					''}`,
			},
			{
				label: '订单平均响应时长',
				value: this.info.avgRespTime,
			},
		]
	}

	@Watch('activeKey')
	private onActiveChange() {
		this.initTab()
	}

	private getNumStr(num: any) {
		if (num || num === 0) {
			return num + '单'
		}
		return '--'
	}

	private logClick() {
		this.getLogList()
		this.visible = true
	}

	private handleCancel() {
		this.visible = false
	}

	private exportList() {
		this.exportingList = true
		const form = (this.$refs.list as any).getForm()
		form.visitorId = this.$route.params.id
		PartnerApi.exportOrderList(form)
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private getVisitorAnalysis() {
		VisitorsApi.getVisitorAnalysis(this.$route.params.mobile).then(
			(res: any) => {
				this.info = res.data
			}
		)
	}

	private getVisitorWorkInfo() {
		VisitorsApi.getVisitorWorkInfo(this.$route.params.id).then((res: any) => {
			this.basicInfo = res.data
		})
	}

	private getLogList() {
		this.logList = []
		VisitorsApi.logList({
			visitorId: this.$route.params.id,
			pageNum: 1,
			pageSize: 9999,
		}).then((res: any) => {
			this.logList = res.data
			this.logList.forEach((item: any) => {
				this.$set(
					item,
					'createTime',
					moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
				)
			})
		})
	}

	private removeMobile(deviceId: string) {
		this.$confirm({
			title: '提示',
			content: '请确认是否删除常用手机？',
			onOk: () => {
				return VisitorsApi.deleteDevice({
					visitorId: this.$route.params.id,
					deviceId,
				}).then(() => {
					this.getVisitorWorkInfo()
				})
			},
		})
	}

	private initTab() {
		if (this.activeKey === '1') {
			this.getVisitorAnalysis()
		} else if (this.activeKey === '2') {
			this.getVisitorWorkInfo()
		}
	}

	private deactivated() {
		unwatch && unwatch()
	}

	private activated() {
		unwatch && unwatch()
		unwatch = this.$watch(
			'$route',
			() => {
				this.initTab()
			},
			{ immediate: true }
		)
	}
}
